const FACEBOOK_APP_ID = "1067279711339593";
const COOKIE_EXPIRED_TIME = 7;

const SIZE_TOP_COURSE = 10;
export { FACEBOOK_APP_ID, COOKIE_EXPIRED_TIME, SIZE_TOP_COURSE };
